import { useState } from 'react';
import { Bell, X } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { datumDe } from '@/lib/format';

type Props = {
  datum: string | null;
  grund: string | null;
  onSave: (datum: string | null, grund: string | null) => void;
};

export function WiedervorlageEditor({ datum, grund, onSave }: Props) {
  const [open, setOpen] = useState(false);
  const [d, setD] = useState(datum ?? '');
  const [g, setG] = useState(grund ?? '');

  if (datum && !open) {
    return (
      <div className="inline-flex items-center gap-2 rounded-md bg-coral-soft px-3 py-1 text-sm text-coral">
        <Bell className="h-4 w-4" />
        <span>Wiedervorlage am {datumDe(datum)}{grund ? ` — ${grund}` : ''}</span>
        <button
          type="button"
          onClick={() => { setD(datum); setG(grund ?? ''); setOpen(true); }}
          className="text-xs underline-offset-2 hover:underline"
        >
          Bearbeiten
        </button>
        <button
          type="button"
          onClick={() => onSave(null, null)}
          className="ml-1"
          aria-label="Wiedervorlage entfernen"
        >
          <X className="h-3 w-3" />
        </button>
      </div>
    );
  }

  if (!open) {
    return (
      <button
 data-nutzung="wiedervorlage"        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex min-h-[44px] items-center gap-1.5 text-sm text-ink-soft hover:text-akzent"
      >
        <Bell className="h-4 w-4" />
        Wiedervorlage setzen
      </button>
    );
  }

  return (
    <div className="inline-flex flex-wrap items-center gap-2 text-sm">
      <input
        type="date"
        value={d}
        onChange={(e) => setD(e.target.value)}
        className="min-h-[44px] rounded border border-line bg-cream px-2 py-1"
      />
      <input
        type="text"
        value={g}
        onChange={(e) => setG(e.target.value)}
        placeholder="Grund (optional)"
        className="min-h-[44px] rounded border border-line bg-cream px-2 py-1"
      />
      <Button
        variant="primary"
        onClick={() => { onSave(d || null, g.trim() === '' ? null : g.trim()); setOpen(false); }}
      >
        Setzen
      </Button>
      <Button variant="ghost" onClick={() => setOpen(false)}>Abbrechen</Button>
    </div>
  );
}
